import type { CallStructuredSummary } from '../../voice-agents/types';

const REQUIRED_KEYS: (keyof CallStructuredSummary)[] = [
  'resumen',
  'dolor_principal',
  'necesidad',
  'presupuesto',
  'timeline_decision',
  'nivel_interes',
  'probabilidad_cierre',
  'propuesta_sugerida',
  'proximos_pasos',
];

function isCallStructuredSummary(value: unknown): value is CallStructuredSummary {
  if (!value || typeof value !== 'object') return false;
  const obj = value as Record<string, unknown>;
  return REQUIRED_KEYS.some((key) => key in obj);
}

export function parseCallStructuredSummary(
  input: CallStructuredSummary | string | null | undefined,
): CallStructuredSummary | null {
  if (!input) return null;

  if (typeof input === 'object') {
    return isCallStructuredSummary(input) ? input : null;
  }

  if (typeof input === 'string') {
    const trimmed = input.trim();
    if (!trimmed.startsWith('{')) return null;
    try {
      const parsed: unknown = JSON.parse(trimmed);
      return isCallStructuredSummary(parsed) ? (parsed as CallStructuredSummary) : null;
    } catch {
      return null;
    }
  }

  return null;
}
